import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const pointApi = createApi({
  reducerPath: 'pointApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/giftshopuse/`,
  }),
  endpoints: (builder) => ({
    getReqs: builder.query({
      query: () => ({
        url: `count`,
      })
    })
  }),
})

export const { useGetReqsQuery } = pointApi